import { render } from "./DialogEntityProperty.vue?vue&type=template&id=08137489"
import script from "./DialogEntityProperty.vue?vue&type=script&lang=js"
export * from "./DialogEntityProperty.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__